import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setDefaultMetaTags, setMetaTags } from "../redux/Slice/metaTagsSlice";

/**
 * Хук для управления мета-тегами страницы
 * @param {{
 *   metaTitle?: string
 *   metaDescription?: string
 * } | undefined} metaTags - Объект с мета-данными
 * @param {string} [metaTags.metaTitle] - Заголовок страницы (если пустая строка или undefined, будет использовано значение по умолчанию)
 * @param {string} [metaTags.metaDescription] - Описание страницы (если пустая строка или undefined, будет использовано значение по умолчанию)
 * @example
 * // Установка кастомных мета-тегов
 * useMetaTags({
 *   metaTitle: "Мой заголовок",
 *   metaDescription: "Мое описание"
 * });
 *
 * // Сброс к значениям по умолчанию (если передать пустые значения)
 * useMetaTags({
 *   metaTitle: "",
 *   metaDescription: ""
 * });
 */

export const useMetaTags = (metaTags = {}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setMetaTags({
        metaTitle: metaTags.metaTitle,
        metaDescription: metaTags.metaDescription,
      }),
    );

    return () => dispatch(setDefaultMetaTags());
  }, [metaTags, dispatch]);
};
